import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "hm_cookie_consent";

const readConsent = () => {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch (_) {
    return "unavailable";
  }
};

const saveConsent = (value) => {
  try {
    localStorage.setItem(STORAGE_KEY, value);
  } catch (_) {}
};

/** Thông báo cookie dạng thẻ nhỏ ở góc (không che nội dung như dải full-width cũ). */
const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!readConsent()) setVisible(true);
  }, []);

  const choose = (value) => {
    saveConsent(value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="region"
      aria-label="Thông báo cookie"
      className="fixed inset-x-3 bottom-[76px] z-[850] animate-slide-up rounded-2xl bg-white p-4 shadow-pop ring-1 ring-black/5 sm:inset-x-auto sm:left-5 sm:max-w-[380px] lg:bottom-5"
    >
      <p className="m-0 text-base leading-relaxed text-slate-600">
        <span className="font-semibold text-slate-900">HealthyMall dùng cookie</span> để cải thiện trải nghiệm mua sắm và phân tích lượt truy cập.{" "}
        <Link to="/trang/chinh-sach-bao-mat" className="font-medium text-brand-700 underline underline-offset-2">
          Tìm hiểu thêm
        </Link>
      </p>
      <div className="mt-3 flex gap-2">
        <button
          type="button"
          onClick={() => choose("essential")}
          className="h-9 flex-1 rounded-lg border border-slate-200 text-base font-medium text-slate-700 transition-colors hover:bg-slate-50"
        >
          Chỉ thiết yếu
        </button>
        <button
          type="button"
          onClick={() => choose("accepted")}
          className="h-9 flex-1 rounded-lg bg-brand-600 text-base font-semibold text-white transition-colors hover:bg-brand-700"
        >
          Đồng ý
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
